/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".share-link[_ngcontent-%COMP%]{border-bottom:1px solid #e2e2e2}.share-link[_ngcontent-%COMP%]   .share-button__badge[_ngcontent-%COMP%]{background:#4caf50;font-size:9px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share-link/share-link.component.styl.shim.ngstyle.js.pre-build-optimizer.js